import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { NbDialogService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { Router } from '@angular/router';
import { CONSTANTS } from 'src/Core/Constant';
import { ConfirmApprovalModalComponent } from '../../Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { FormApprovalSuccessModalComponent } from '../../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { ConfirmRejectionModalComponent } from '../../Modalla-Popup/confirm-rejection-modal/confirm-rejection-modal.component';
import { FormRejectionSuccessModalComponent } from '../../Modalla-Popup/form-rejection-success-modal/form-rejection-success-modal.component';
import { catchError, of } from 'rxjs';

interface Seva {
  seva: string;
  SevaSinceWhen: string;
  SevaHowOften: string;
  SupervisorName: string;
  SaveMode?: number;
  Id?: number;
  ApplicationGuid?: string;
  ApplicationNumber?: string;
  SevaTypeCode?: any;
  CompletionPercentage?: number;
  IsActive?: boolean;
}

@Component({
  selector: 'app-add-reference',
  templateUrl: './add-reference.component.html',
  styleUrls: ['./add-reference.component.scss']
})
export class AddReferenceComponent implements OnInit {

  isJsonShow = environment.isJsonShow;
  referenceForm!: FormGroup;
  SevaForm!: FormGroup;
  submitted = false;
  sevaSubmitted = false;
  sevaListArray: Seva[] = [];
  applicationId: any;
  SaveMode = CONSTANTS.SAVE_MODE;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private api: SevaProfileService,
    private genericValidations: GenericValidationsService,
    private dialogService: NbDialogService,
    private cd: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.applicationId = history?.state?.rowData;
    this.initializeSevaForm();
    this.initializeReferenceForm();
    this.getApplicantData();
    this.setupConditionalValidation();
  }

  /** Initialize Seva Form */
  initializeSevaForm(): void {
    this.SevaForm = this.fb.group({
      seva: ['', Validators.required],
      SevaSinceWhen: ['', Validators.required],
      SevaHowOften: ['', Validators.required],
      SupervisorName: ['', Validators.required]
    });
  }

  /** Initialize Main Reference Form */
  initializeReferenceForm(): void {
    this.referenceForm = this.fb.group({
      ApplicationGuid: [this.applicationId?.ApplicationGuid, Validators.required],
      ApplicationNumber: [''],
      SaveMode: [''],
      NameOfApplicant: [''],
      date: ['', Validators.required],
      NameOfPersonGivingReference: ['', Validators.required],
      YearsKnown: ['', Validators.required],
      Capacity: ['', Validators.required],
      CurrentlyParticipatingCenter: ['', Validators.required],
      CenterCode: [''],
      CenterAttendanceFrequencyCode: [''],
      CenterAttendanceFrequency: ['', Validators.required],
      ReasonForNotGoing: ['', Validators.required],
      ParticipatedInShaktipatIntensive: ['', Validators.required],
      LastIntensiveYear: ['', Validators.required],
      WhyNotParticipatedIntensive: [''],
      OffersSeva: ['', Validators.required],
      ReasonForNotOfferingSeva: ['', Validators.required],
      PhysicalLimitations: ['', Validators.required],
      PhysicalLimitationsComments: [''],
      RecommendVisitingSevite: ['', Validators.required],
      ReasonNotRecommendVisitingSevite: ['', Validators.required],
      RecommendRetreat: ['', Validators.required],
      ReasonNotRecommendRetreat: ['', Validators.required],
      AdditionalComments: ['', Validators.required],
      COCReferenceSevaOfferInformationList: this.fb.array([])
    });
  }

  /** Setup conditional validators for dynamic fields */
  setupConditionalValidation(): void {
    // CurrentlyParticipatingCenter -> CenterAttendanceFrequency (when true) / ReasonForNotGoing (when false)
    // This needs custom handling as it has two different dependent fields
    this.referenceForm.get('CurrentlyParticipatingCenter')?.valueChanges.subscribe(val => {
      const freq = this.referenceForm.get('CenterAttendanceFrequency');
      const reason = this.referenceForm.get('ReasonForNotGoing');
      if (val === true) {
        freq?.setValidators([Validators.required]);
        freq?.updateValueAndValidity();
        // Clear and hide reason field
        reason?.clearValidators();
        reason?.setValue('');
        reason?.updateValueAndValidity();
      } else if (val === false) {
        reason?.setValidators([Validators.required]);
        reason?.updateValueAndValidity();
        // Clear and hide frequency field
        freq?.clearValidators();
        freq?.setValue('');
        freq?.updateValueAndValidity();
      }
    });

    // ParticipatedInShaktipatIntensive -> LastIntensiveYear (show when true)
    this.genericValidations.setupFormListeners(
      this.referenceForm,
      { ParticipatedInShaktipatIntensive: ['LastIntensiveYear'] },
      true // isShowOn = true means show when value === true
    );





    this.referenceForm.get('OffersSeva')?.valueChanges.subscribe(val => {
      const reason = this.referenceForm.get('ReasonForNotOfferingSeva');
      
      if (val === false) {
        // If NO, require reason
        reason?.setValidators([Validators.required]);
        reason?.updateValueAndValidity();
    
        // Clear SevaForm and Seva list
        this.SevaForm.reset();
        this.sevaListArray = [];
        const arr = this.referenceForm.get('COCReferenceSevaOfferInformationList') as FormArray;
        arr.clear();
      } else if (val === true) {
        // If YES, clear reason field
        reason?.clearValidators();
        reason?.setValue('');
        reason?.updateValueAndValidity();
      }
    });
    





    // OffersSeva -> ReasonForNotOfferingSeva
    // this.referenceForm.get('OffersSeva')?.valueChanges.subscribe(val => {
    //   const reason = this.referenceForm.get('ReasonForNotOfferingSeva');
    //   if (val === false) reason?.setValidators([Validators.required]);
    //   else reason?.clearValidators();
    //   reason?.updateValueAndValidity();
    // });

    // RecommendVisitingSevite -> ReasonNotRecommendVisitingSevite (show when false)
    this.genericValidations.setupFormListeners(
      this.referenceForm,
      { RecommendVisitingSevite: ['ReasonNotRecommendVisitingSevite'] },
      false // isShowOn = false means show when value !== true (i.e., false)
    );

    // RecommendRetreat -> ReasonNotRecommendRetreat (show when false)
    this.genericValidations.setupFormListeners(
      this.referenceForm,
      { RecommendRetreat: ['ReasonNotRecommendRetreat'] },
      false // isShowOn = false means show when value !== true (i.e., false)
    );
  }

  /** Get applicant data and patch form */
  getApplicantData(): void {
    if (!this.applicationId?.ApplicationGuid) return;

    this.api.apiCall(`COC/application-details?ApplicationGuid=${this.applicationId.ApplicationGuid}`, 'GET')
      .pipe(catchError(err => {
        this.toastr.error('Failed to load applicant data');
        return of(null);
      }))
      .subscribe((response: any) => {
        if (response?.IsSuccess && response.Data) {
          const data = response.Data;

          if (data.COCReferenceInfomration) {
            const refData = data.COCReferenceInfomration;
            this.referenceForm.patchValue({
              ApplicationGuid: refData.ApplicationGuid,
              ApplicationNumber: refData.ApplicationNumber,
              NameOfApplicant: refData.NameOfApplicant,
              date: refData.Date,
              NameOfPersonGivingReference: refData.NameOfPersonGivingReference,
              YearsKnown: refData.YearsKnown,
              Capacity: refData.Capacity,
              CurrentlyParticipatingCenter: refData.CurrentlyParticipatingCenter,
              CenterCode: refData.CenterCode,
              CenterAttendanceFrequencyCode: refData.CenterAttendanceFrequencyCode,
              CenterAttendanceFrequency: refData.CenterAttendanceFrequency,
              ReasonForNotGoing: refData.ReasonForNotGoing,
              OffersSeva: refData.OffersSeva,
              ReasonForNotOfferingSeva: refData.ReasonForNotOfferingSeva,
              ParticipatedInShaktipatIntensive: refData.ParticipatedInShaktipatIntensive,
              LastIntensiveYear: refData.LastIntensiveYear,
              WhyNotParticipatedIntensive: refData.WhyNotParticipatedIntensive,
              PhysicalLimitations: refData.PhysicalLimitations,
              PhysicalLimitationsComments: refData.PhysicalLimitationsComments,
              RecommendVisitingSevite: refData.RecommendVisitingSevite,
              ReasonNotRecommendVisitingSevite: refData.ReasonNotRecommendVisitingSevite,
              RecommendRetreat: refData.RecommendRetreat,
              ReasonNotRecommendRetreat: refData.ReasonNotRecommendRetreat,
              AdditionalComments: refData.AdditionalComments,
              SaveMode: refData.SaveMode
            });
          }

          if (data.COCReferenceSevaOfferInformationList?.length) {
            this.sevaListArray = data.COCReferenceSevaOfferInformationList.map((s: any) => ({
              seva: s.Seva,
              SevaSinceWhen: s.SevaSinceWhen,
              SevaHowOften: s.SevaHowOften,
              SupervisorName: s.SupervisorName
            }));

            const arr = this.referenceForm.get('COCReferenceSevaOfferInformationList') as FormArray;
            arr.clear();
            data.COCReferenceSevaOfferInformationList.forEach((s: any) => {
              arr.push(this.fb.group({
                seva: s.Seva,
                SevaSinceWhen: s.SevaSinceWhen,
                SevaHowOften: s.SevaHowOften,
                SupervisorName: s.SupervisorName,
                SaveMode: s.SaveMode,
                Id: s.Id,
                ApplicationGuid: s.ApplicationGuid,
                ApplicationNumber: s.ApplicationNumber,
                SevaTypeCode: s.SevaTypeCode,
                CompletionPercentage: s.CompletionPercentage,
                IsActive: s.IsActive
              }));
            });
          }
        }
      });
  }

  /** Add a new Seva entry */
  addSeva(): void {
    this.sevaSubmitted = true;
    if (this.SevaForm.valid) {
      const sevaData = this.SevaForm.value as Seva;
      this.sevaListArray.push(sevaData);

      const arr = this.referenceForm.get('COCReferenceSevaOfferInformationList') as FormArray;
      arr.push(this.fb.group({
        Seva: sevaData.seva,
        SevaSinceWhen: sevaData.SevaSinceWhen,
        SevaHowOften: sevaData.SevaHowOften,
        SupervisorName: sevaData.SupervisorName,
        SaveMode: 1,
        Id: 0,
        ApplicationGuid: this.applicationId?.ApplicationGuid,
        ApplicationNumber: this.referenceForm.get('ApplicationNumber')?.value || '',
        SevaTypeCode: null,
        CompletionPercentage: 0,
        IsActive: true
      }));

      this.SevaForm.reset();
      this.sevaSubmitted = false;
    }
  }

  /** Remove Seva entry */
  removeSeva(index: number): void {
    const arr = this.referenceForm.get('COCReferenceSevaOfferInformationList') as FormArray;
    if (index > -1) {
      arr.removeAt(index);
      this.sevaListArray.splice(index, 1);
    }
  }

  /** Submit form */
  onSubmit(Mode: number): void {
    this.referenceForm.patchValue({
      SaveMode: Mode,
      ApplicationGuid: this.applicationId?.ApplicationGuid
    });

    if (!this.referenceForm.valid && Mode === this.SaveMode.SAVE) {
      this.submitted = true;
      this.toastr.warning('Please complete all required fields before submitting.');
      return;
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.referenceForm.value);
    this.addUpdate(cleanedValues, Mode);
    this.submitted = true;
  }

  /** Save or update form */
  addUpdate(reqBody: any, Mode: number): void {
    if (reqBody.COCReferenceSevaOfferInformationList?.length) {
      reqBody.COCReferenceSevaOfferInformationList.forEach((arg: any) => arg.SaveMode = Mode);
    }

    const payload = this.convertToApiPayload(reqBody);

    this.api.apiCall('COC/save-COC-reference', 'POST', payload)
      .pipe(catchError(err => {
        this.toastr.error('Failed to save data');
        return of(null);
      }))
      .subscribe((res: any) => {
        if (res?.Message) this.toastr.success(res.Message);
        if (Mode === this.SaveMode.DRAFT) this.getApplicantData();
      });
  }

  /** Convert form data to API payload */
  convertToApiPayload(flat: any) {
    return {
      CompletionPercentage: 0,
      IsActive: true,
      Id: 0,
      ApplicationGuid: flat.ApplicationGuid,
      formMode: 0,
      SaveMode: flat.SaveMode,
      COCReferenceInfomration: {
        ...flat,
        Date: flat.date
      },
      COCReferenceSevaOfferInformationList: flat.COCReferenceSevaOfferInformationList?.map((o: any) => ({
        ...o,
        Seva: o.seva || o.Seva,
        CompletionPercentage: 0,
        IsActive: true,
        Id: 0,
        ApplicationGuid: flat.ApplicationGuid,
        ApplicationNumber: flat.ApplicationNumber,
        SaveMode: flat.SaveMode
      }))
    };
  }

  /** Modal helpers */
  private openModal(component: any, data: any = {}): void {
    const dialogRef = this.dialogService.open(component, {
      context: { data },
      closeOnBackdropClick: false,
      hasScroll: true
    });
    dialogRef.onClose.subscribe();
  }

  OpenModalRej(): void {
    const dialogRef = this.dialogService.open(ConfirmRejectionModalComponent, {
      context: { data: { name: 'Chetan', city: "Malegaon" } },
      closeOnBackdropClick: false,
      hasScroll: true
    });

    dialogRef.onClose.subscribe(res => res && this.FormRejectSuccessfully());
  }

  FormRejectSuccessfully(): void {
    this.openModal(FormRejectionSuccessModalComponent, { name: 'Chetan', city: "Malegaon" });
  }

  OpenApprovalModal(): void {
    const dialogRef = this.dialogService.open(ConfirmApprovalModalComponent, {
      context: { data: { name: 'Chetan', city: "Malegaon" } },
      closeOnBackdropClick: false,
      hasScroll: true
    });

    dialogRef.onClose.subscribe(res => res && this.FormApproveSuccessfully());
  }

  FormApproveSuccessfully(): void {
    this.openModal(FormApprovalSuccessModalComponent, { name: 'Chetan', city: "Malegaon" });
  }



/** Reset the form values and SevaForm */
/** Reset only the responses, keep applicant info intact */
resetResponse(): void {
  // Reset main form answers but keep applicant info
  this.referenceForm.patchValue({
    YearsKnown: '',
    Capacity: '',
    CurrentlyParticipatingCenter: '',
    CenterAttendanceFrequency: '',
    ReasonForNotGoing: '',
    ParticipatedInShaktipatIntensive: '',
    LastIntensiveYear: '',
    WhyNotParticipatedIntensive: '',
    OffersSeva: '',
    ReasonForNotOfferingSeva: '',
    PhysicalLimitations: '',
    PhysicalLimitationsComments: '',
    RecommendVisitingSevite: '',
    ReasonNotRecommendVisitingSevite: '',
    RecommendRetreat: '',
    ReasonNotRecommendRetreat: '',
    AdditionalComments: ''
  });



  this.SevaForm.reset();
this.sevaListArray = [];
const arr = this.referenceForm.get('COCReferenceSevaOfferInformationList') as FormArray;
arr.clear();
this.referenceForm.patchValue({
  ReasonForNotOfferingSeva: ''
});

  // Reset SevaForm


  // Clear Seva list array and FormArray
 


  // Reset submitted flag to hide validation errors
  this.submitted = false;

  // Trigger change detection for UI update
  this.cd.detectChanges();
}



}